import React, { useState, useEffect } from "react";
import { Tabs, Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

// == Import SCSS
import "./visitDayPage.less";

// == Import icons
import { IoMdCalendar } from "react-icons/io";
import { WiSunrise, WiSunset, WiDaySunny } from "react-icons/wi";

// == import i18n
import { useTranslation } from "react-i18next";
import { updateVisitsFromDay } from "services/features/VisitsSlice";

const VisiDayPage = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { currentVisits } = useSelector(state => state.visits);
  const [allStatusCount, setAllStatusCount] = useState({});

  const [selectedTabs, setSelectedTabs] = useState("morning");

  useEffect(() => {
    if (moment().format("HH:mm:ss") > moment("12:00:01", "HH:mm:ss").format("HH:mm:ss")) {
      setSelectedTabs("afternoon");
    }
  }, []);

  useEffect(() => {
    dispatch(updateVisitsFromDay(moment()));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const allStatusCount = currentVisits
      .filter(v => {
        const operation = selectedTabs === "morning" ? "isBefore" : "isAfter";
        if (selectedTabs === "morning" || selectedTabs === "afternoon") {
          return moment(v.startDate)[operation](moment("12:00:01", "HH:mm:ss"));
        } else {
          return moment(v.startDate);
        }
      })
      .reduce((acc, visit) => {
        for (const visitor of visit.visitors) {
          acc[visitor.status] = (acc[visitor.status] || 0) + 1;
        }
        return acc;
      }, {});

    setAllStatusCount(allStatusCount);
  }, [currentVisits, selectedTabs]);

  console.log("allStatusCount", allStatusCount);

  const contentWaiting = (
    <div>
      <p>{t("DayVisitExpected")}</p>
    </div>
  );

  const contentRegistered = (
    <div>
      <p>{t("DayVisitRegistered")}</p>
    </div>
  );

  const contentCheckin = (
    <div>
      <p>{t("DayVisitCheckIn")}</p>
    </div>
  );

  const contentCheckout = (
    <div>
      <p>{t("DayVisitCheckOut")}</p>
    </div>
  );

  return (
    <div className="visitDay">
      <p className="visitDay__title">{t("FindVisitDay")}</p>

      <section className="visitDay__section">
        <p className="visitDay__section__date" style={{ marginBottom: "0px" }}>
          {moment().format("DD/MM/YYYY")} <IoMdCalendar />
        </p>
        <Tabs
          activeKey={selectedTabs}
          onChange={val => {
            setSelectedTabs(val);
          }}
        >
          <Tabs.TabPane
            tab={
              <span>
                <WiSunrise />
                {t("Morning")}
              </span>
            }
            key="morning"
          >
            <Popover content={contentWaiting} placement="bottom" title="Attendu">
              <p className="tabs__text" id="wait">
                {allStatusCount.expected || allStatusCount.null
                  ? allStatusCount.expected || allStatusCount.null
                  : "0"}{" "}
                <span>
                  {allStatusCount.expected || allStatusCount.null > 1
                    ? t("Waiting") + "s"
                    : t("Waiting")}
                </span>
              </p>
            </Popover>
            <Popover content={contentRegistered} placement="bottom" title="Enregistré">
              <p className="tabs__text" id="visit">
                {allStatusCount.registered ? allStatusCount.registered : "0"}{" "}
                <span>
                  {allStatusCount.registered > 1 ? t("Registered") + "s" : t("Registered")}
                </span>
              </p>
            </Popover>
            <Popover content={contentCheckin} placement="bottom" title="En visite">
              <p className="tabs__text" id="checkin">
                {allStatusCount.checkin ? allStatusCount.checkin : "0"} <span>{t("Checkin")}</span>
              </p>
            </Popover>
            <Popover content={contentCheckout} placement="bottom" title="Check-out">
              <p className="tabs__text" id="checkout">
                {allStatusCount.checkout ? allStatusCount.checkout : "0"}{" "}
                <span>{t("Checkout")}</span>
              </p>
            </Popover>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span>
                <WiSunset />
                {t("Afternoon")}
              </span>
            }
            key="afternoon"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span>
                <WiDaySunny />
                {t("Day")}
              </span>
            }
            key="day"
          ></Tabs.TabPane>
        </Tabs>
      </section>
    </div>
  );
};

export default VisiDayPage;
